import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import issuer_services from "services/issuer_services";
import { networkTypeSelector } from "store/userSliceHelpers";
import { useSettlementToken } from "features/tokens/useSettlementToken";

export function useRedeemedBalance() {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  const { param: token } = useSettlementToken();
  return useQuery({
    // Per-token: a USDC redeem accumulates at the treasury sink exactly as a VIP one does.
    queryKey: ["redeemedBalance", token],
    queryFn: () => issuer_services.getRedeemedBalance(networkType, token),
    enabled: !!user,
  });
}
